export default "__VITE_ASSET__DWbyxW9T__"